module.exports = __webpack_public_path__ + "img/defaulmod.2d45a745.png";